<template>
  <v-app light>
    <v-main class="grey darken-3">
      <slot />
    </v-main>

    <app-footer color="secondary darken-1" />
  </v-app>
</template>

<script>
import AppFooter from '@/components/common/AppFooter.vue'

export default {
  name      : 'LoginLayout',
  components: {AppFooter},
  mixins    : [],
  data() {
    return {}
  },
  computed: {},
  watch   : {},
  created() {
    this.$bus.$emit('show-app-loading-modal', false)
  },
  mounted() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  methods: {}
}

</script>

<style scoped>

</style>
